import normalizeConnectionSetupPayload from '@/lib/connections/normalizeConnectionSetupPayload.js';

/**
 * What the conversation's connection card needs from a `connection_setup` interaction: the app, whether
 * it is a connect or a reconnect, what Pieve said, and the outcome once the card is answered.
 *
 * The outcome is the event's `outcome` (written by the OAuth callback, by a credential that became
 * valid elsewhere, or by the person's answer through a run's `eventUpdate`), else what a separate
 * response event says (`connected`, `dismissed`, or `connected: false` for a failed one). No outcome
 * means the card is still open: the same test the API uses to find open cards.
 */
const toConnectionCard = (item) => {
  const connectionSetup = normalizeConnectionSetupPayload(item?.payload);
  const response = item?.response && typeof item.response === 'object' ? item.response : {};
  let outcome = String(item?.outcome || '').trim() || null;

  if (!outcome && response.connected === true) {
    outcome = 'connected';
  } else if (!outcome && response.dismissed === true) {
    outcome = 'dismissed';
  } else if (!outcome && response.connected === false) {
    outcome = 'failed';
  }

  return {
    interactionId: String(item?.interactionId || item?.id || ''),
    runId: item?.runId || null,
    prompt: String(item?.prompt || item?.title || '').trim(),
    isReconnect: connectionSetup.setup.mode === 'reconnect',
    connectionSetup,
    outcome
  };
};

export default toConnectionCard;
